module.exports = __webpack_public_path__ + "img/icon_package_pink.7ea8f763.png";